import React, { useState, useEffect ,useContext} from 'react';
import './SliderTab.css';
import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';
import generateKey from '/src/utils/generateKey';

function SliderTab ({ items , classNameTab, classNameIndicator, name, type , onTabChange }){
    const [selectedIndex, setSelectedIndex] = useState(0); 
    const [itemsListed,setItemsListed] = useState(items); 
    // const { selectedTabName, setSelectedTabName } = useContext(TabNameContext);
    const handleItemClick = (index) => {
        setSelectedIndex(index);
        if (onTabChange) {
            onTabChange(index, items[index].type); 
        }
        ScrollIntoSlide(items[index].name, name);
    };


    const getSearchTableContainer = () => {
        return [...document.getElementsByClassName('search-container')];
    } 

    const cloneSearchContainer = () => {
        const searchContainerBis = document.querySelector('.search-container-bis');
        searchContainerBis.innerHTML = '';
        const searchContainerFirst = getSearchTableContainer()[selectedIndex];
        const searchContainerFirstClone = searchContainerFirst.cloneNode(true);
        searchContainerFirstClone.style.display = 'flex';
        const buttonsFirstClone = [...searchContainerFirstClone.getElementsByTagName('button')];
        const buttonsFirst = [...searchContainerFirst.getElementsByTagName('button')];
        buttonsFirstClone.map((button, index) => button.addEventListener('click', () => buttonsFirst[index].dispatchEvent(new MouseEvent('click', { bubbles: true }))))
        const inputsFirstClone = [...searchContainerFirstClone.getElementsByTagName('input')];
        const inputsFirst = [...searchContainerFirst.getElementsByTagName('input')];
        inputsFirstClone.map((input, index) => input.addEventListener('input', () => {
            var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
            nativeInputValueSetter.call(inputsFirst[index], input.value);
            inputsFirst[index].dispatchEvent(new KeyboardEvent('keyup',{ key: 'Enter', bubbles: true, cancelable: true}));
        }))
        searchContainerBis.appendChild(searchContainerFirstClone);
    }

    const calculateIndicatorPosition = () => {
        const tabWidth = 100 / itemsListed.length;
        if(type != 'table') {
            return `translateX(${tabWidth * selectedIndex * itemsListed.length }%)`;
        }
        
        const containers = getSearchTableContainer();
        containers.map(el => el.style.display = 'none')
        if(containers.length) cloneSearchContainer();
        return `translateX(${tabWidth * selectedIndex * itemsListed.length }%)`;
    };

    useEffect(() => {
        getSearchTableContainer().length && calculateIndicatorPosition();
    }, [])
    useEffect( ()=>{
        setItemsListed([...items])
    },[items])
    return (
      <>
        <div className="tab-menu-container">
            <div className={"tab-menu-tabs " + classNameTab}>
                {itemsListed.map((item, index) =><div key={generateKey()} className={`tab ${index === selectedIndex ? 'active' : ''}`} onClick={() => handleItemClick(index)}>{item.name}</div>)}
            </div>
            <div className={"tab-indicator " + classNameIndicator} style={{transform: calculateIndicatorPosition(), width: document.querySelector('.tab.active')?.offsetWidth || 140 }}/>
            <div className='search-container-bis'></div>
        </div>
        <Slider className="tab-menu">
            {items.map((item, index) => {
                console.log(item) 
                return (
                    <Slide name={item.name} key={index} className={name}>
                        {item?.component}
                    </Slide>
                )
            })}
        </Slider>
      </>
    );
  };
  

SliderTab.defaultProps = {
    items : [],
    classNameTab:'',
    classNameIndicator:'',
    type : 'table'
}

export default SliderTab;
